import { t, TLabel } from "util/stdtypes";

export const ModerationFilters: Record<string, { id: string, text: TLabel, emoji: string }> = {
    AwaitingDecision: { id: "awaiting_decision", text: t("Awaiting decision"), emoji: "🔍" },
    AutomaticallyApproved: { id: "auto_approved", text: t("Automatically approved"), emoji: "✅" },
    HumanApproved: { id: "human_approved", text: t("Manually approved"), emoji: "🕵️" },
    Rejected: { id: "rejected", text: t("Manually rejected"), emoji: "⛔️" },
    Warned: { id: "warned", text: t("Warnings"), emoji: "🚦" },
    Deleted: { id: "deleted", text: t("Deleted by user"), emoji: "🗑️" },
    Bookmarked: { id: "bookmarked", text: t("My bookmarks"), emoji: "🔖" },
};

export const ModerationFiltersDefault = [
    ModerationFilters.AwaitingDecision,
    ModerationFilters.AutomaticallyApproved,
    ModerationFilters.HumanApproved,
    ModerationFilters.Rejected,
];
